/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SendRegistrationEmailSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('SEND_REGISTRATION_EMAIL')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class SendRegistrationEmailSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SendRegistrationEmailSettingParser.decode(input).map(res => new SendRegistrationEmailSetting(res));
    }
    static unsafeDecode(input) {
        return SendRegistrationEmailSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SendRegistrationEmailSettingParser.encode(data);
    }
    static schema() {
        return SendRegistrationEmailSettingParser.schema();
    }
}
